import React from "react"

export type Props = {
  url: string
}

const PodcastEmbed = ({ url }: Props) => (
  <div>
    <iframe
      title="Audio embed player"
      src={url}
      height="200"
      width="100%"
      style={{ border: "none" }}
    />
  </div>
)

export default PodcastEmbed
